import { render, staticRenderFns } from "./ModalSavAgreement.vue?vue&type=template&id=67e59f8c&scoped=true&"
import script from "./ModalSavAgreement.vue?vue&type=script&lang=js&"
export * from "./ModalSavAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ModalSavAgreement.vue?vue&type=style&index=0&id=67e59f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e59f8c",
  null
  
)

export default component.exports